import template from './admin-fax-details.html';
import {adminStates} from './../../admin-routes';

AdminFaxDetails.DIRECTIVE_NAME = 'ktAdminFaxDetails';
export default function AdminFaxDetails() {
    return {
        restrict: 'A',
        template,
        controller: AdminFaxDetailsController,
        controllerAs: 'adminFaxDetailsCtrl',
        link: function($scope, $elem, $attrs, adminFaxDetailsCtrl) {
            adminFaxDetailsCtrl.$onInit();
        },
    };
}

export function AdminFaxDetailsController(
    $window,
    $state,
    $stateParams,
    l10nService,
    adminFaxDetailsService
) {
    'ngInject';

    const vm = this;

    Object.assign(vm, {
        $onInit,
        sendFaxToNewFaxNumber,
        newFaxNumber: null,
    });

    function $onInit() {
        vm.referenceNo = $stateParams.referenceNo;
        vm.faxNumber = $stateParams.faxNumber;
        vm.pdfUrl = adminFaxDetailsService.getPdfUrl($stateParams.hash);
    }

    function sendFaxToNewFaxNumber() {
        const successfulMessage = 'Fax successfully sent';
        adminFaxDetailsService.sendFaxToNewFaxNumber($stateParams.faxId, vm.newFaxNumber)
            .then(() => {
                vm.faxNumber = vm.newFaxNumber;
                vm.newFaxNumber = null;
                const traslation = l10nService.localize(successfulMessage);
                $window.alert(traslation);
                $state.go(adminStates.FAX_LIST_RESULTS);
            });
    }
}



// WEBPACK FOOTER //
// ./src/app/modules/admin/admin-fax/admin-fax-details/admin-fax-details-component.js